import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

let appCheck: AppCheck | undefined;

// Initialize App Check
if (process.env.NODE_ENV === 'development') {
  // @ts-ignore
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = '0F80FEDE-F2C2-4E47-B456-5DECFFEF5F0F';
}

// Initialize App Check only if it hasn't been initialized yet
try {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Leiq0UrAAAAAP-xYnAdXYkeOfi9M4eSOTnUrPTR'),
    isTokenAutoRefreshEnabled: true
  });
} catch (error: any) {
  if (error.code === 'appCheck/already-initialized') {
    console.warn('AppCheck is already initialized.');
  } else {
    console.error('Error initializing AppCheck:', error);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);